// extracted by mini-css-extract-plugin
export default {"links":"profile_edit_nav_links___links___c62f9ddb"};